import React from "react";
import { Link } from "react-scroll";
import classes from "./Link.module.css";
const MyLink = (props) => {
  return (
    <Link
      activeClass={props.noactive ? null : classes.Active}
      to={props.to}
      spy={true}
      smooth={true}
      offset={-100}
      onClick={props.click}
    >
      {props.children}
      {props.name}
    </Link>
  );
};

export default MyLink;
